import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";

import {
	setDate,
	openAddReservationDialog,
	activateTableLinkMode,
	activateTableLinkDeletionMode
} from "../../actions/store/app-actions";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {
	showAdditionalInfo,
	hideAdditionalInfo,
	toggleInfoBar,
	setActiveArea
} from "../../actions/store/overview-actions";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { setLoginStatusAndAuthInfo } from "../../actions/auth-actions";

interface State {
	mobileMenuAnchor: HTMLElement;
}

export interface MobileMenuProps {}

interface ConnectedMobileMenuProps extends WithStyles<typeof styles> {}

type Props = MobileMenuProps &
	ConnectedMobileMenuProps &
	InjectedTranslateProps;

export class MobileMenu extends React.Component<Props, State> {
	public state: State = {
		mobileMenuAnchor: null
	};

	handleMobileMenuButtonClick = (
		event: React.MouseEvent<HTMLButtonElement>
	) => {
		this.setState({ mobileMenuAnchor: event.currentTarget });
	};

	handleMobileMenuClose = () => {
		this.setState({ mobileMenuAnchor: null });
	};

	private handleLogoutMenuItemClick = () => {
		sessionStorage.removeItem("token");
		sessionStorage.removeItem("authInfo");

		setLoginStatusAndAuthInfo(false);
	};

	public render() {
		const { children } = this.props;
		const { mobileMenuAnchor } = this.state;

		return (
			<React.Fragment>
				<IconButton
					color="inherit"
					onClick={this.handleMobileMenuButtonClick}
				>
					<MoreVertIcon />
				</IconButton>
				<Menu
					anchorEl={mobileMenuAnchor}
					open={Boolean(mobileMenuAnchor)}
					onClick={this.handleMobileMenuClose}
				>
					{children}
					<MenuItem onClick={this.handleLogoutMenuItemClick}>
						Abmelden
					</MenuItem>
				</Menu>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({});

const styles = (theme: Theme) => createStyles({});

export const ConnectedMobileMenu = translate("translations")(
	withStyles(styles)(connect(mapStateToProps)(MobileMenu))
);
